import React from 'react';
import { Row, Col } from 'react-bootstrap5';
import * as Yup from 'yup';
import { Formik, Form as FormikForm } from 'formik';

import Footer from 'components/Widgets/Profile/FormFooter';
import HorizontalSelectField from 'components/new_ui/Form/HorizontalSelectField';
import HorizontalDateField from 'components/new_ui/Form/HorizontalDateField';
import { useContext as useUsersContext } from 'components/Users/Context';
import Actions from 'components/Members/Profile/Actions';
import Modal from 'components/new_ui/Modal/Modal';

import { useNavigate } from 'react-router-dom';

import useIndustries from 'components/Common/Industries/Hooks/useIndustries';
import useCareerLevels from 'components/Common/CareerLevels/Hooks/useCareerLevels';
import useYearExperiences from 'components/Common/YearExperiences/Hooks/useYearExperiences';

import employmentTypes from 'data/employment_types';

const transformValues = (values) => ({
  industry_ids: values.industries,
  career_level_id: values.careerLevel,
  year_experience_id: values.yearExperience,
  hired_date: values.hiredDate
    ? new Date(values.hiredDate.getTime()
      - values.hiredDate.getTimezoneOffset() * 60 * 1000).toISOString().split('T')[0] : null,
  employment_type: values.employmentType,
});

export default function Experience() {
  const { dispatch: dispatchUsers, actions: actionsUsers, state: stateUsers } = useUsersContext();

  const { industries } = useIndustries();
  const careerLevels = useCareerLevels();
  const yearExperiences = useYearExperiences();

  const navigate = useNavigate();

  const member = stateUsers.user.attributes.specific;

  const formSchema = Yup.object().shape({

  });

  const onSubmitHundler = (values, { setSubmitting, setErrors }) => {
    Actions.update(
      member.id,
      transformValues(values),
      false,
      () => {
        setSubmitting(false);
        actionsUsers.load(dispatchUsers);
        navigate(-1);
      },
      (errors) => {
        const newErrors = {};
        errors.errors.forEach((item) => {
          newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
        });
        setErrors(newErrors);
        setSubmitting(false);
      },
    );
  };

  return (
    <Modal size="lg" show>
      <Formik
        validationSchema={formSchema}
        initialValues={{
          industries: member.industry_ids.map((el) => el.toString()),
          careerLevel: member.career_level_id,
          yearExperience: member.year_experience_id,
          hiredDate: new Date(member.hired_date),
          employmentType: member.employment_type,
        }}
        onSubmit={onSubmitHundler}
      >
        {({ isSubmitting }) => (
          <FormikForm className="needs-validation" noValidate="">
            <Row>
              <Col md={6}>
                <HorizontalSelectField
                  name="industries"
                  label="Industries"
                  isMulti
                  placeholder={industries.length === 0 ? 'Loading...' : 'Select Industries'}
                  options={industries.map((el) => ({
                    label: el.attributes.title,
                    value: el.id,
                  }))}
                />
              </Col>
              <Col md={6}>
                <HorizontalSelectField
                  name="careerLevel"
                  label="Career Level"
                  placeholder={careerLevels === null ? 'Loading...' : 'Select Career Level'}
                  options={careerLevels == null ? [] : careerLevels.map((el) => ({
                    label: el.attributes.title,
                    value: parseInt(el.id, 10),
                  }))}
                />
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <HorizontalSelectField
                  name="yearExperience"
                  label="Years of Experience"
                  placeholder={yearExperiences === null ? 'Loading...' : 'Select Years of Experience'}
                  options={yearExperiences == null ? [] : yearExperiences.map((el) => ({
                    label: el.attributes.title,
                    value: parseInt(el.id, 10),
                  }))}
                />
              </Col>
              <Col md={6}>
                <HorizontalDateField
                  name="hiredDate"
                  label="Hired Date"
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <HorizontalSelectField
                  name="employmentType"
                  label="Employment Type"
                  placeholder="Select Employment Type"
                  options={employmentTypes}
                />
              </Col>
            </Row>

            <Footer loading={isSubmitting} onCancel={() => navigate(-1)} />
          </FormikForm>
        )}
      </Formik>
    </Modal>
  );
}
